import { useSelector } from "react-redux";
import { getUserProfile } from "../../../../configuration/login/loginSlice";
import BlipChat from "./blipChat";

const ChameVolks: React.FC<{ handleBackToList: () => void }> = ({ handleBackToList }) => {
  const selectedCode = { title: 'uptime', code: import.meta.env.VITE_BLIP_CHAT_APP_KEY, customCommonUrl: import.meta.env.VITE_BLIP_CHAT_CUSTOM_COMMON_URL };

  const userProfile = useSelector(getUserProfile);

  return (
    <div className="chat-view flex flex-col h-full">
      <div className="chat-header flex justify-between items-center bg-[#000000] text-[#ffffff] px-4 py-2">
        <button
          onClick={handleBackToList}
          className="text-white focus:outline-none"
        >
          <span className="rioglyph rioglyph-arrow-left text-color-primary"></span>
        </button>
        <h3 className="text-size-h4 font-bold insert-title">Mensagens</h3>
      </div>

      <div className="h-full w-full">
        <BlipChat
          accessibilityLabel={selectedCode.title}
          appKey={selectedCode.code}
          customCommonUrl={selectedCode.customCommonUrl}
          userIdentity={userProfile?.sub?.split(":")[1] ?? ''}
        />
      </div>
    </div>
  );
};

export default ChameVolks;